module["exports"] = [
  "Azərbaycan"
];
